import { render, staticRenderFns } from "./OrderableAddressPreview.vue?vue&type=template&id=85dd4bba&"
import script from "./OrderableAddressPreview.vue?vue&type=script&lang=ts&"
export * from "./OrderableAddressPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports